module.exports = __webpack_public_path__ + "53c8f6df6103bfc5f2212544359e3868.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/avocado.png
// module id = 1961
// module chunks = 0